import styled from 'styled-components';
import { defaultTheme } from 'styles/theme/default';

export const Line = styled.tr`
    width: 100%;
    height: 48px;

    td {
      text-align: center;
    }

    .bodyLine:nth-child(2n) {
        background-color: #F5F5F5;
    }

    .boxAmount {
      display: flex;
      gap: 8px;
      justify-content: center;
      align-items: center;
    }
    .editBoxesIcon{
        font-size: 18px;
        fill: ${defaultTheme.colors['gray-300']};
        cursor: pointer;
        opacity: 0;
        transition: opacity 100ms;
    }

    .editBoxesIcon:hover {
        opacity: 1;
    }

    .editReturnDateIcon {
      font-size: 20px;
      fill: ${defaultTheme.colors['gray-300']};
      cursor: pointer;
      transition: opacity 100ms;
    }

    @media screen and (max-width:769px) {
        .editBoxesIcon {
            opacity: 1;
        }
    }
`;

export const SidebarContainer = styled.div`
  height: 100%;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;

  .infos {
    margin-bottom: 28px;

    h3 {
      color: #353535;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 1.5rem;
      line-height: 29px;
    }

    @media screen and (max-width: 769px) {
      h3 {
        font-size: 17px;
        line-height: 24px;
      }
    }
  }


  .spacer {
    height: 20px;
  }

  @media screen and (max-width: 769px) {
    .infos {
      margin-bottom: 16px;
    }

    .spacer {
      height: 10px;
    }

    padding: 0;
  }
`;
